module.exports = __webpack_public_path__ + "img/1f99e.c5ef954.svg";